// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Row, Col, Typography, Form, Button, Select, Input, Drawer, InputNumber, message } from 'antd';
import PropTypes from 'prop-types';
import BloodRequestDetailsForm from '../detail';
import { fetchBloodTypes } from 'services/blood_bank/blood_types';
import { getHospitalList } from 'services/blood_bank/hospital'
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import { createBloodRecipient, partialUpdateBloodRequest } from 'services/blood_recipient/blood_recipient'
// import { fetchBloodProducts } from 'services/blood_bank/blood_types';
import { AlphaInput, NumberInput } from 'shared_components/pattern_input';
import HttpCodeMessage from 'shared_components/message_http_status'
import { messagePrompts } from './settings'
import moment from 'moment';
const { Text } = Typography;

const { Option } = Select;


class BloodRequestDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      loading: false,
      recipientDetail: {},
      requestDetails: [],
      enableButton: true,
      bloodType: [],
      getHospitallist:[],
      showUpdateButton:false
    }; 
    this.formRef = React.createRef();
  }

  async componentDidMount() {
    await this.fetchData();
    const response =  await getHospitalList();
    this.setState({
      getHospitallist:response
    })
  }

  onCloseDrawer = () => {
    this.setState({ displayDrawer: false });
  }

  fetchData = async () => {
    const bloodTypeList = await fetchBloodTypes();
    this.setState({ 
      loading: true, 
      bloodType: bloodTypeList 
    });
  }

  computeAge = (date) => {
		const years = Math.floor(moment().diff(date, 'years', true));
		const age = years > 0 ? years : '---';
	
		return age;
  }

  onUpdate= ()=>{
    this.setState({
      showUpdateButton:true
    })
  }
  
  onCancel = () => {
    this.setState({
      showUpdateButton:false
    })
  } 

  onSubmit = async(values) => {
    const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
    const { selectedRequest , action } = this.props;

      if(action === 'ADD'){

        const payload = {
          request_products_id: selectedRequest.request_products_id,
          blood_product:selectedRequest.blood_product_id,
          recipient:selectedRequest.recipient_id,
          quantity: values.quantity,
          priority: values.priority,
          status:selectedRequest.status_id,
          diagnosis: values.diagnosis,
          physician:selectedRequest.physician_id,
          hospital:selectedRequest.hospital_id,
          blood_unit: 1,
          purpose: "sample purpose",
          created_by: loggedinUser.userID,
        }
        console.log(values)
        const APIresponse =  await createBloodRecipient(payload);
        
        if(APIresponse.status === 201){
          const httpMessageConfig = {
            message: messagePrompts.successCreateUser,
            
            status: APIresponse.status,	
            duration: 3, 
            onClose: () => window.location.reload() 
          }
          HttpCodeMessage(httpMessageConfig);	
        }	
      }
    else  {
      const payload = {
        blood_product:selectedRequest.blood_product_id,
        recipient:selectedRequest.recipient_id,
        request_products_id: selectedRequest.request_products_id,
        quantity: values.quantity,
        priority: values.priority,
        status:selectedRequest.status_id,
        diagnosis: values.diagnosis,
        physician:selectedRequest.physician_id,
        hospital:selectedRequest.hospital_id,
        blood_unit: 0,
        purpose: "string",
        updated_by: loggedinUser.userID
      }
      console.log(values)
      const APIresponse =  await partialUpdateBloodRequest(payload);

      if(APIresponse.status === 200){
        const httpMessageConfig = {
          message: messagePrompts.successUpdateUser,
          
          status: APIresponse.status,
          duration: 3, 
          onClose: () => window.location.reload() 
        }
        HttpCodeMessage(httpMessageConfig);
      }
    }
    
  }

  closeDrawer = this.props; 

  render(){
    const { 
      recipientDetail, 
      requestDetails, 
      closeDrawer, 
      bloodType, 
      drawerTitle, 
      displayDrawer, 
      getHospitallist,
      showUpdateButton
     } = this.state;

    const { selectedRequest, drawerButton, disableButton } = this.props;
    console.log("🚀 ~ file: index.js ~ line 125 ~ BloodRequestDetails ~ render ~ selectedRequest", selectedRequest)

    const BloodTypeOptions = bloodType.map(item => (
      <Option key={item.blood_type_id} value={item.blood_type}>
        {item.blood_type}
      </Option>
    ));

    const HospitalOptions = getHospitallist.map(item => (
      <Option key={item.hospital_id} value={item.hospital_name}>
        {item.hospital_name}
      </Option>
    ));

    return(
      <Row>
        <Form 
          layout="vertical"
          ref={this.formRef}
          onFinish={this.onSubmit}
          >
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item 
                label="FIRST NAME" 
                name="first_name"
                initialValue={selectedRequest.first_name}
                >
                  <Input
                    style={{width:200}}
                    placeholder="First Name"
                    disabled = {disableButton}
                  />
                </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="MIDDLE NAME" 
                name="middleName"
                initialValue={selectedRequest.middle_name}
                >
                  <Input 
                    style={{width:200}}
                    maxLength={1}
                    disabled = {disableButton}
                    placeholder="Middle Name"
                  />
                </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="LAST NAME" 
                name="lastName"
                initialValue={selectedRequest.last_name}
                >
                  <Input 
                    style={{width:200}}
                    disabled = {disableButton}
                    maxLength={20}
                    placeholder="Last Name"
                  />
                </Form.Item>
            </Col>
            <Col span={6}>  
              <Form.Item 
                label="SUFFIX" 
                name="suffix"
                initialValue={selectedRequest.suffix}
              >
                  <Input 
                    style={{width:100}}
                    maxLength={5}
                    disabled = {disableButton}
                    placeholder="SUFFIX"
                  />
                </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item 
                label="DATE OF BIRTH"
                name="birth_date"
                initialValue={selectedRequest.birth_date}
                >
                <Input 
                  style={{width:200}}
                  maxLength={5}
                  disabled = {disableButton}
                />
              </Form.Item>
            </Col>
            <Col span={6}>  
              <Form.Item 
                label="AGE" 
                name="age" 
                initialValue={this.computeAge(selectedRequest.birth_date)}
              >
                  <Input 
                    disabled = {disableButton}
                    style={{width:200}}
                    maxLength={5}
                  />
                </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="GENDER" 
                name="genders" 
                initialValue={selectedRequest.gender}
              >
                <Input 
                  disabled = {disableButton}
                  style={{width:200}}
                  maxLength={5}
                />
              </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="ADDRESS" 
                name="address" 
                initialValue={selectedRequest.city_name}
              >
                <Select 
                  style={{width:200}}
                  disabled = {disableButton}
                  value={recipientDetail.address_line_1}
                />
                </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}> 
            <Form.Item 
                label="DIAGNOSIS" 
                name="diagnosis"
                initialValue={selectedRequest.diagnosis}
                >
                  <Input
                    style={{width:200}}
                    placeholder="Diagnosis"
                    disabled = {disableButton}
                  />
                </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="REQUESTING HOSPITAL" 
                name="requestingHospital" 
                initialValue={selectedRequest.hospital_name}
              >
                <Select
                  showSearch
                  style={{ width: 200 }}
                  placeholder="Hospital"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {HospitalOptions}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}> 
              <Form.Item 
                label="PHYSICIAN" 
                name="physician" 
                initialValue={selectedRequest.physician_name}
              >
                  <Input 
                    style={{width:200}}
                    disabled = {disableButton}
                    value={recipientDetail.physician}
                  />
              </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="LICENSE NO" 
                name="licenseNo" 
                initialValue={selectedRequest.license_no}
              >
                  <Input 
                    style={{width:200}}
                    maxLength={20}
                    value={recipientDetail.license_no}
                    disabled = {disableButton}
                  />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}> 
              <Form.Item 
                label="BLOOD TYPE" 
                name="bloodType" 
                initialValue={selectedRequest.blood_type}
              >
                <Select
                  style={{width:200}}
                  value={recipientDetail.blood_type}
                  disabled = {disableButton}
                >
                  {BloodTypeOptions}
                </Select>
                  
              </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="PRIORITY" 
                name="priority"
                initialValue={selectedRequest.priority_id}
              >
                <Select 
                  style={{width:200}}
                  value={recipientDetail.priority_id}
                  disabled = {disableButton}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}> 
              <Form.Item 
                label="BLOOD PRODUCT" 
                name="bloodProduct" 
                initialValue={selectedRequest.blood_product_name}
              >
                <Select
                  style={{width:200}}
                  disabled
                  defaultValue='BLOOD PRODUCT'
                >
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}> 
              <Form.Item 
                label="QUANTITY" 
                name="quantity"
                initialValue={selectedRequest.quantity}
                >
                <InputNumber min={0} max={10} /*defaultValue={0}*/ style={{width:200}}/>
              </Form.Item>
            </Col>
          </Row>
          <section className="drawerFooter">
            {
              drawerButton === 'ADD' && (
                <div>
                  <Button
                    shape="round"
                    style={{ marginRight: 10, width: 120 }}
                    onClick={closeDrawer}
                  >
                    CANCEL
                  </Button>
                  <Button
                    type="primary"
                    shape="round"
                    htmlType="submit"
                    style={{ margin: 10, width: 120 }}
                  >
                    {drawerButton}
                  </Button>
                </div>
              )
            }
            {
              drawerButton === 'UPDATE REQUEST' && ( 
                  showUpdateButton === true ?
                  (		
                    <>
                      <Button
                        shape="round"
                        style={{ marginRight: 10, width: 150 }}
                        onClick={this.onCancel}
                      >
                        CANCEL
                      </Button>
                      <Button
                        shape="round"
                        style={{ margin: 10, width: 150 }}
                        onClick={this.onSubmit}
                      >
                        UPDATE
                      </Button>
                      </>
                  )	
                  :
                    <div>
                      <Button
                        shape="round"
                        style={{ marginRight: 10, width: 150 }}
                        onClick={closeDrawer}
                      >
                        CANCEL REQUEST
                      </Button>
                      <Button
                        // type="primary"
                        shape="round"
                        onClick={this.onUpdate}
                        htmlType="submit"
                        // loading={loading}
                        style={{ margin: 10, width: 150 }}
                      >
                        {drawerButton}
                      </Button>
                      <Button
                        shape="round"
                        style={{ marginRight: 10, width: 150 }}
                        onClick={closeDrawer}
                      >
                        PROCESS REQUEST
                      </Button>
                      <Button
                        shape="round"
                        style={{ marginRight: 10, width: 150 }}
                        onClick={closeDrawer}
                      >
                        PRINT
                      </Button>
                  </div>
              )
            }
          </section>
        </Form>
      </Row>
    );
  }
}

BloodRequestDetails.propTypes = {
  selectedRequest: PropTypes.object,
  action:PropTypes.string
};


export default BloodRequestDetails;